var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLockSwitch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 1C6.66304 1 7.29893 1.26339 7.76777 1.73223C8.23661 2.20107 8.5 2.83696 8.5 3.5V5C8.89782 5 9.27936 5.15803 9.56066 5.43934C9.84196 5.72064 10 6.10217 10 6.5V9.5C10 9.89782 9.84196 10.2794 9.56066 10.5607C9.27936 10.842 8.89782 11 8.5 11H3.5C3.10218 11 2.72064 10.842 2.43934 10.5607C2.15804 10.2794 2 9.89782 2 9.5V6.5C2 6.10217 2.15804 5.72064 2.43934 5.43934C2.72064 5.15803 3.10218 5 3.5 5V3.5C3.5 2.83696 3.76339 2.20107 4.23223 1.73223C4.70107 1.26339 5.33696 1 6 1ZM6 7C5.74771 6.99992 5.50472 7.0952 5.31973 7.26675C5.13474 7.43829 5.02142 7.67342 5.0025 7.925L5 8C5 8.19778 5.05865 8.39112 5.16853 8.55557C5.27841 8.72002 5.43459 8.84819 5.61732 8.92388C5.80004 8.99957 6.00111 9.01937 6.19509 8.98078C6.38907 8.9422 6.56725 8.84696 6.70711 8.70711C6.84696 8.56725 6.9422 8.38907 6.98078 8.19509C7.01937 8.00111 6.99957 7.80004 6.92388 7.61732C6.84819 7.43459 6.72002 7.27841 6.55557 7.16853C6.39112 7.05865 6.19778 7 6 7ZM6 2C5.60217 2 5.22064 2.15804 4.93934 2.43934C4.65803 2.72064 4.5 3.10217 4.5 3.5V5H7.5V3.5C7.5 3.10217 7.34196 2.72064 7.06066 2.43934C6.77936 2.15804 6.39782 2 6 2Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLockSwitch);
export default __webpack_public_path__ + "static/media/icon-lock-switch.aa1b4b6b7b9795a6f5c5a495f7076e9c.svg";
export { ForwardRef as ReactComponent };